import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/NewIndex'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/NewIndex',
        name: 'NewIndex',
        component: () => import('../views/newViews/NewIndex.vue')
    },
    {
        path: '/noticeTitle',
        name: 'noticeTitle',
        component: () => import('../views/NoticeTitle.vue')
    },
    {
        path: '/noticeText',
        name: 'noticeText',
        component: () => import('../views/NoticeText.vue')
    },
    {
        path: '/faq/:id',
        name: 'faq',
        component: () => import('../views/Faq.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/Register.vue')
    },
    {
        path: '/newRegister',
        name: 'newRegister',
        component: () => import('../views/newViews/NewRegister.vue')
    },
    {
        path: '/pricing',
        name: 'pricing',
        component: () => import('../views/Pricing.vue')
    },
    {
        path: '/newPricing',
        name: 'newPricing',
        component: () => import('../views/newViews/NewPricing.vue')
    },
    {
        path: '/productDetails',
        name: 'productDetails',
        component: () => import('../views/ProductDetails.vue')
    },
    {
        path:'/newControllerInfo',
        name: 'newControllerInfo',
        component: () => import('../views/newViews/NewControllerInfo.vue')
    },
    {
        path:'/newControllerRecharge',
        name: 'newControllerRecharge',
        component: () => import('../views/newViews/NewControllerRecharge.vue')
    },
    {
        path: '/newControllerDetails',
        name: 'newControllerDetails',
        component: () => import('../views/newViews/NewControllerDetails.vue')
    },
    {
        path: '/newControllerKey',
        name: 'newControllerKey',
        component: () => import('../views/newViews/NewControllerKey.vue')
    },
    {
        path: '/newDocs',
        name: 'newDocs',
        component: () => import('../views/newViews/NewDocs.vue')
    },
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: () => import('../views/newViews/ForgetPassword.vue')
    },
    {
        path: '/WXpay',
        name: 'WXpay',
        component: () => import('../views/newViews/WXpay.vue')
    }
];

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 始终滚动到顶部
        return { x: 0, y: 0 };
    },
    mode: 'history',
});

// 添加路由守卫 - 登录判定
router.beforeEach((to, from, next) => {
    // 需要登录验证的路由名称列表
    const requiresAuth = [
        'newControllerInfo',
        'newControllerRecharge',
        'newControllerDetails',
        'newControllerKey',
        'newDocs'
    ];

    // 检查目标路由是否需要登录验证
    if (requiresAuth.includes(to.name)) {
        // 检查用户是否已登录（通过 localStorage 或其他方式）
        const loginToken = localStorage.getItem('loginToken') || Cookies.get('loginToken');
        if (loginToken) {
            // 已登录，允许访问
            next();
        } else {
            // 未登录，重定向到登录页或首页
            next('/');
        }
    } else {
        // 不需要登录验证的路由，直接访问
        next();
    }
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
    });
};

export default router;
